$(document).on('click', '[data-order-cart]', function() {
  const $this = $(this);
  $this.addClass('loading');
});
